import { Component } from "@angular/core";

@Component({
    templateUrl: "./role-manager-component.html"
})
export class RoleManagerComponent {

}